import { useEffect, useMemo } from 'react';

export interface StagedImagePreview {
  stagedPreviewUrl: string | null;
  hasStagedImage: boolean;
}

export const useStagedImagePreview = (
  files?: File[] | null
): StagedImagePreview => {
  const stagedFile: File | null = files?.[0] ?? null;

  const stagedPreviewUrl: string | null = useMemo(
    () => (stagedFile ? URL.createObjectURL(stagedFile) : null),
    [stagedFile]
  );

  useEffect(() => {
    if (!stagedPreviewUrl) {
      return;
    }

    return () => URL.revokeObjectURL(stagedPreviewUrl);
  }, [stagedPreviewUrl]);

  return {
    stagedPreviewUrl,
    hasStagedImage: stagedFile !== null,
  };
};
